import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withI18n, withI18nProps } from '@lingui/react'
import compose from 'lodash/fp/compose'

import prepareComponent from 'client/shared/decorators/prepare-component'
import { loadTemplate } from 'client/shared/reducers/templates-reducer'
import { isEUCountry, isLatAmCountry } from 'shared/tools/country-helpers'

import LegalLayout from 'client/bookmate/blocks/legal-layout'
import HeaderBox from 'client/shared/boxes/header-box'
import Footer from 'client/shared/blocks/footer'
import MetaTitle from 'client/shared/blocks/meta-title'
import { MetaDescription } from 'client/shared/blocks/meta-description'

import { CurrentUserState } from 'client/shared/types/current-user'
import { Dispatch, State } from 'shared/types/redux'

function getTemplateLocale({ locale, country }) {
  if (country === 'ua' || locale === 'uk') return 'uk'
  if (country === 'de' || locale === 'de') return 'de'
  if (isEUCountry(country)) return 'eu'
  if (isLatAmCountry(country) || locale === 'es') return 'es'

  return locale === 'ru' ? 'ru' : 'en'
}

type Props = {
  templates: string[]
  currentUser: CurrentUserState
  dispatch: Dispatch
  params: { subItem?: string }
} & withI18nProps

class LegalPage extends Component<Props> {
  render() {
    const {
      templates,
      currentUser: { data },
      params: { subItem = '' },
    } = this.props
    const locale = getTemplateLocale(data)

    const templateName = `legal-layout-${locale}`
    const template = templates[templateName] || {}

    return (
      <>
        {this.renderMeta()}
        <HeaderBox />
        <LegalLayout template={template} locale={locale} subItem={subItem} />
        <Footer aboutMenu />
      </>
    )
  }

  renderMeta() {
    const { i18n } = this.props
    const headTitle = i18n.t`legal.head_title`
    const description = i18n.t`legal.meta_description`

    return (
      <>
        <MetaTitle title={headTitle} />
        <MetaDescription description={description} />
      </>
    )
  }
}

const prepareWrapper = prepareComponent(
  async function ({ store }) {
    const {
      currentUser: { data },
    } = store.getState()
    const templateName = `legal-layout-${getTemplateLocale(data)}`

    await store.dispatch(loadTemplate({ templateName }))
  },
  {
    userListener: true,
  },
)

const connectWrapper = connect((state: State) => ({
  currentUser: state.currentUser,
  templates: state.templates,
}))

const wrappers = compose(
  prepareWrapper,
  connectWrapper,
  withI18n({ update: true }),
)

export default wrappers(LegalPage)
